import { render } from "./PlatformLogsPagination.vue?vue&type=template&id=7b3abd32&scoped=true&ts=true"
import script from "./PlatformLogsPagination.vue?vue&type=script&lang=ts"
export * from "./PlatformLogsPagination.vue?vue&type=script&lang=ts"

import "./PlatformLogsPagination.vue?vue&type=style&index=0&id=7b3abd32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3abd32"]])

export default __exports__